import { useEffect, useState } from 'react';
import { usePoint } from '../context/PointContext';
import $ from 'jquery';

function PointHistory() {
    const memberId = localStorage.getItem("lighthouse_memberId");
    const isLoggedIn = memberId && memberId !== 'null' && memberId !== 'undefined';

    const { point } = usePoint();

    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const APIKEY = process.env.REACT_APP_UNSE_API_KEY;
    const siteCode = process.env.REACT_APP_SITE_CODE_LIGHTHOUSE;

    useEffect(() => {
        if (isLoggedIn) {
            fetchHistory(1);
        } else {
            setLoading(false);
        }
    }, [isLoggedIn]);

    const fetchHistory = (pageNum) => {
        setLoading(true);

        $.ajax({
            url: `${API_BASE_URL}/getPointHistory`,
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({
                member_id: memberId,
                site_code: siteCode,
                page: pageNum,
                limit: 20
            }),
            headers: { APIKEY: APIKEY },
            success: function (res) {
                setLoading(false);
                if (res.code === '0') {
                    if (pageNum === 1) {
                        setHistory(res.list || []);
                    } else {
                        setHistory(prev => [...prev, ...(res.list || [])]);
                    }
                    setHasMore((res.list || []).length >= 20);
                    setPage(pageNum);
                }
            },
            error: function (err) {
                setLoading(false);
                console.error("포인트 내역 조회 에러:", err);
            }
        });
    };

    const loadMore = () => {
        if (!loading && hasMore) {
            fetchHistory(page + 1);
        }
    };

    const getReasonText = (reason) => {
        const reasonMap = {
            'welcome': '가입 축하',
            'attendance': '출석 체크',
            'unse_view': '운세 열람',
            'admin_grant': '관리자 지급',
            'event': '이벤트'
        };
        return reasonMap[reason] || reason;
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${month}/${day} ${hours}:${minutes}`;
    };

    if (!isLoggedIn) {
        return (
            <div style={{
                padding: 'clamp(40px, 10vw, 50px) 20px',
                textAlign: 'center',
                color: '#aaa',
                maxWidth: '540px',
                margin: '0 auto'
            }}>
                <div style={{ fontSize: 'clamp(36px, 9vw, 48px)', marginBottom: '20px' }}>&#128274;</div>
                <p style={{ fontSize: 'clamp(14px, 3.5vw, 16px)' }}>로그인 후 이용해주세요.</p>
            </div>
        );
    }

    return (
        <div className="pointHistoryContent" style={{
            padding: '20px',
            paddingBottom: '40px',
            maxWidth: '540px',
            margin: '0 auto',
            boxSizing: 'border-box',
            position: 'relative',
            zIndex: 99
        }}>
            <div style={{
                background: 'linear-gradient(135deg, rgba(255,215,0,0.2) 0%, rgba(255,180,0,0.1) 100%)',
                borderRadius: '16px',
                padding: 'clamp(15px, 4vw, 25px)',
                marginBottom: '20px',
                textAlign: 'center',
                border: '1px solid rgba(255,215,0,0.3)'
            }}>
                <div style={{ fontSize: 'clamp(12px, 3vw, 14px)', color: '#aaa', marginBottom: '8px' }}>
                    현재 보유 포인트
                </div>
                <div style={{ fontSize: 'clamp(28px, 7vw, 36px)', fontWeight: 'bold', color: '#FFD700' }}>
                    {point.toLocaleString()}P
                </div>
            </div>

            <h3 style={{
                fontSize: 'clamp(14px, 3.5vw, 16px)',
                fontWeight: 'bold',
                color: '#fff',
                marginBottom: '15px',
                paddingLeft: '5px'
            }}>
                포인트 내역
            </h3>

            {history.length === 0 && !loading ? (
                <div style={{ padding: '40px 20px', textAlign: 'center', color: '#888' }}>
                    포인트 내역이 없습니다.
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {history.map((item, index) => (
                        <div
                            key={index}
                            style={{
                                background: '#273250',
                                borderRadius: '12px',
                                padding: 'clamp(12px, 3vw, 15px)',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: '10px'
                            }}
                        >
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{
                                    fontSize: 'clamp(13px, 3.2vw, 14px)',
                                    fontWeight: 'bold',
                                    color: '#fff',
                                    marginBottom: '4px'
                                }}>
                                    {getReasonText(item.POINT_REASON)}
                                </div>
                                <div style={{ fontSize: 'clamp(11px, 2.8vw, 12px)', color: '#888' }}>
                                    {formatDate(item.REG_DATE)}
                                </div>
                            </div>
                            <div style={{ textAlign: 'right', flexShrink: 0 }}>
                                <div style={{
                                    fontSize: 'clamp(14px, 3.5vw, 16px)',
                                    fontWeight: 'bold',
                                    color: item.POINT_TYPE === 'earn' ? '#51cf66' : '#FF6B6B'
                                }}>
                                    {item.POINT_TYPE === 'earn' ? '+' : '-'}{item.POINT_AMOUNT}P
                                </div>
                                <div style={{ fontSize: 'clamp(10px, 2.5vw, 11px)', color: '#888' }}>
                                    잔액 {item.BALANCE_AFTER}P
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {hasMore && history.length > 0 && (
                <button
                    onClick={loadMore}
                    disabled={loading}
                    style={{
                        width: '100%',
                        padding: 'clamp(12px, 3vw, 15px)',
                        marginTop: '15px',
                        fontSize: 'clamp(13px, 3.2vw, 14px)',
                        color: '#fff',
                        background: 'rgba(255,255,255,0.1)',
                        border: '1px solid rgba(255,255,255,0.2)',
                        borderRadius: '10px',
                        cursor: loading ? 'default' : 'pointer'
                    }}
                >
                    {loading ? '로딩 중...' : '더보기'}
                </button>
            )}
        </div>
    );
}

export default PointHistory;
